<template>
  <KTTable
    title="Provincias"
    subtitle="Lista de provincias"
    :fields="fields"
    :items="$store.state.provincias.provincias"
    @delete="deleteItem($event)"
  ></KTTable>
</template>

<script>
import KTTable from "@/view/content/Table.vue";
import { DELETE_PROVINCIA } from "@/core/services/store/provincias.module";

export default {
  name: "dashboard",
  components: { KTTable },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "Id Provincia",
          sortable: true
        },
        {
          key: "provincia",
          label: "Provincia",
          sortable: true
        },
        {
          key: "prefijo8",
          label: "Prefijo*",
          sortable: true
        },
        {
          key: "prefijo9",
          label: "Prefijo9",
          sortable: true
        },
        {
          key: "actions",
          label: ""
        }
      ]
    };
  },
  methods: {
    deleteItem(item) {
      this.$store.commit(DELETE_PROVINCIA, item);
    }
  }
};
</script>
